<template>
  <div class="modal-overlay" v-if="showModal">
    <div class="modal-window">
      <button class="close-btn" @click.self="closeModal">×</button>
      <div class="form-connection-application">
        <div class="form-connection-application__title">
          {{ getLocalization('Leave a connection request and we\'ll get back to you within 24 hours.') }}
        </div>
        <div class="form-connection-application__form">
          <div>
            <div class="--title">{{ getLocalization('Your hardware') }}*</div>
            <multiselect
                v-model="selectedHardware"
                :placeholder="getLocalization('Your hardware or API')"
                :options="hardwareLabels"
                label="title"
                track-by="id"
                :option-height="40"
                :multiple="false"
                :closeOnSelect="true"
                :show-labels="false"
            >
              <template slot="option" slot-scope="props">
                <span>{{ props.option.title }}</span>
              </template>
            </multiselect>
          </div>
          <div>
            <div class="--title">{{ getLocalization('Select countries') }}*</div>
            <multiselect
                v-model="selectedCountries"
                :placeholder="getLocalization('You can choose several countries')"
                :options="countries"
                label="title"
                track-by="id"
                :option-height="40"
                :multiple="true"
                :show-labels="false"
            >
              <template slot="option" slot-scope="props">
                <img :src="props.option.img_path">
                <span>{{ props.option.title }}</span>
              </template>
              <template v-slot:tag="{ option, remove }">
                <div>
                  <img :src="option.img_path">
                  <span>{{ option.title }}</span>
                  <div class="--remove" @click.prevent @mousedown.prevent.stop="remove(option, $event)"></div>
                </div>
              </template>
            </multiselect>
          </div>
          <div>
            <div class="--title">{{ getLocalization('How to contact you (Telegram/WhatsApp/WeChat)') }}*</div>
            <input type="text" v-model="contact" class="input" placeholder="Telegram / WhatsApp / WeChat"/>
          </div>
          <div>
            <div class="--title">{{ getLocalization('What else we should know about you?') }}</div>
            <input type="text" v-model="additionalInfoAboutProvider" class="input"
                   :placeholder="getLocalization('Tell us more about you')"/>
          </div>
        </div>
        <!-- Динамическая капча -->
        <div v-if="captchaType === 'cloudflare'" class="cf-turnstile" :data-sitekey="cloudflareSiteKey"></div>
        <div class="form-connection-application__action">
          <div class="--button">
            <button @click="sendForm" class="button orange">
              <img src="/img/form/send.svg"/>
              {{ getLocalization('Send') }}
            </button>
          </div>
          <div class="--privacity">
            {{ getLocalization('I agree') }} <a href="#"
                                                target="_blank">{{ getLocalization('with the privacy policy and use of the requested data') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Multiselect from "vue-multiselect";
  import BaseAdminMixin from "../../../admin/components/mixins/BaseAdminMixin.vue";

  export default {
    name: "connectionAppFormPopup",
    components: {
      Multiselect,
    },
    mixins: [
      BaseAdminMixin
    ],
    props: {
      csrf: {
        type: String,
        required: true
      },
      captchaKey: {
        type: String,
        required: true,
      },
      captchaType: {
        type: String,
        default: 'google_v3'
      },
      cloudflareSiteKey: {
        type: String,
        default: ''
      },
      countries: {
        type: Array,
        required: true,
      },
    },
    mounted() {
      this.loadCaptchaScript()
          .catch((error) => {
            console.error('Failed to load captcha script in popup:', error);
          });
      setTimeout(() => {
        this.showModalIfNotShown();
      }, 30000);

      document.addEventListener('mouseleave', this.handleExitIntent);
      this.getCountries();
    },
    data() {
      return {
        selectedCountries: [],
        selectedHardware: [],
        additionalInfoAboutProvider: '',
        showModal: false,
        modalAlreadyShown: false,
        contact: null,
        captchaToken: null,
        captchaWidgetId: null,
        hardwareLabels: [
          {id: 1, title: this.getLocalization('GSM Modem/Gateway')},
          {id: 2, title: this.getLocalization('GOIP')},
          {id: 3, title: this.getLocalization('API hardware')},
          {id: 4, title: this.getLocalization('Other')},
        ]
      }
    },
    beforeDestroy() {
      this.removeCaptcha();
      document.removeEventListener('mousemove', this.handleExitIntent);
    },
    methods: {

      removeCaptcha() {
        if (this.captchaType === 'cloudflare' && this.captchaWidgetId !== null && window.turnstile?.remove) {
          window.turnstile.remove(this.captchaWidgetId);
          this.captchaWidgetId = null;
        }
      },
      showModalIfNotShown() {
        // if (!this.modalAlreadyShown) {
          this.showModal = true;
          this.modalAlreadyShown = true;
          document.removeEventListener('mouseleave', this.handleExitIntent);
          
          // Инициализируем Cloudflare Turnstile после показа модального окна
          if (this.captchaType === 'cloudflare') {
            this.$nextTick(() => {
              this.initCloudflareWidget();
            });
          }
        // }
      },
      handleExitIntent(e) {
        // если курсор ушёл за верхнюю границу окна
        if (e.clientY <= 0) {
          this.showModalIfNotShown();
        }
      },
      closeModal() {
        this.showModal = false;
      },
      initCloudflareWidget() {
        if (window.turnstile && this.captchaType === 'cloudflare') {
          setTimeout(() => {
            const element = document.querySelector('.modal-window .cf-turnstile');
            if (element && !element.hasChildNodes()) {
              this.captchaWidgetId = window.turnstile.render(element, {
                sitekey: this.cloudflareSiteKey,
                callback: (token) => {
                  this.captchaToken = token;
                },
              });
            }
          }, 100);
        }
      },
      async getCountries() {
        return this.countries;
      },
      async sendForm() {
        await this.getCaptchaToken();
        
        let countryIds = this.selectedCountries.map(el => el['id'])
        let form = {
          countryIds: countryIds,
          hardware: this.selectedHardware,
          additionalInfoAboutProvider: this.additionalInfoAboutProvider,
          contact: this.contact,
          typeId: 20,
          page: 'Referral program popup',
        }
        
        // Динамическое добавление поля капчи
        const captchaField = this.captchaType === 'cloudflare' ? 'cf-turnstile-response' : 'g-recaptcha-response';
        form[captchaField] = this.captchaToken;
        await this.doWithStopRequest(() => this.doWithLoader(async () => {
          let response = await this.sendRequest(
              '/sendConnectionApp',
              'post',
              form);
          if (response) {
            await this.alertMessage(
                this.getLocalization('You question has been sent'),
                'good'
            );
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          }
        }));
      },
      async loadCaptchaScript() {
        if (this.captchaType === 'cloudflare') {
          if (window.turnstile) return Promise.resolve();
          const script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
          return Promise.resolve();
        } else {
          if (window.grecaptcha) return Promise.resolve();
          return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${this.captchaKey}`;
            script.async = true;
            script.defer = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
          });
        }
      },
      async getCaptchaToken() {
        if (this.captchaType === 'cloudflare') {
          return new Promise((resolve) => {
            const checkToken = () => {
              if (this.captchaToken) {
                resolve(this.captchaToken);
              } else if (this.captchaWidgetId && window.turnstile) {
                const response = window.turnstile.getResponse(this.captchaWidgetId);
                if (response) {
                  this.captchaToken = response;
                  resolve(response);
                } else {
                  setTimeout(checkToken, 100);
                }
              } else {
                setTimeout(checkToken, 100);
              }
            };
            checkToken();
          });
        } else {
          return new Promise((resolve) => {
            window.grecaptcha.ready(() => {
              window.grecaptcha.execute(this.captchaKey, {action: 'connection_app_popup'}).then((token) => {
                this.captchaToken = token;
                resolve(token);
              });
            });
          });
        }
      }
    }
  }
</script>
<style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }

  .modal-window {
    background: #fff;
    padding: 30px;
    border-radius: 10px;
    max-width: 600px;
    width: 90%;
    position: relative;
  }

  .close-btn {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 24px;
    border: none;
    background: transparent;
    cursor: pointer;
  }
</style>